import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import { Route, Switch, Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import CreatePasswordPage from '../CreatePasswordPage';
import SignInPage from '../SignInPage';
import ResetPasswordPage from '../ResetPasswordPage';
import SignUpPage from '../SignUpPage';

import styles from './SignedOutHomePage.css';

class SignedOutHomePage extends Component {
    static propTypes = {
        children: PropTypes.node,
    };

    render() {
        return (
            <div className={styles.page}>
                <div className={styles.title}>
                    <FormattedMessage id="ExternalPageTemplate.TofT" />
                </div>
                <Paper className={styles.paper} zDepth={3}>
                    <Switch>
                        <Route exact path="/" component={SignUpPage} />
                        <Route exact path="/signin" component={SignInPage} />
                        <Route path="/reset-password" component={ResetPasswordPage} />
                        <Route path="/set-password/:token" component={CreatePasswordPage} />
                        <Redirect to="/" />
                    </Switch>
                </Paper>
            </div>
        );
    }
}

export default SignedOutHomePage;



// WEBPACK FOOTER //
// ./src/Pages/SignedOutHomePage/SignedOutHomePage.js